var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterrogationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_175)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13.95,
    stroke: "current",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12V11.1938C11.5 9.15379 13.1635 7.5 15.2036 7.5V7.5C17.0753 7.5 18.6564 8.90738 18.8631 10.7677L18.9216 11.2942C18.9725 11.7521 18.8716 12.2139 18.6347 12.6089L17.9981 13.6698C17.6728 14.212 17.1996 14.6502 16.634 14.933V14.933C16.5453 14.9774 16.4642 15.0358 16.394 15.106L16.134 15.366C16.0449 15.4551 15.9648 15.5528 15.8949 15.6577L15.836 15.7461C15.2909 16.5637 15 17.5244 15 18.5071V19",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 22,
    r: 0.5,
    stroke: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrogationMark);
export default __webpack_public_path__ + "static/media/interrogationMark.7a9965b40fa864e18e2a67f08a5a50a3.svg";
export { ForwardRef as ReactComponent };